export const isMobile = window.innerWidth >= 768;
export const isTabletViewport =
  window.innerWidth > 768 && window.innerWidth < 992;
export const isDesktopViewport = window.innerWidth >= 992;
